import angular from 'angular';
import directive from './rich-text-editor.directive';
import token from './token';
import service from './richTextEditor.service';


export default angular.module('app.components.global.richTextEditor', [
  token,
])
  .service('richTextEditorService', service)
  .directive('richTextEditor', directive)
  .name;

console.log('app.components.global.richTextEditor created');
